import {
  MINIMUM_LENGTH,
  PASSWORD_DIGIT_REGEX,
  PASSWORD_LOWERCASE_REGEX,
  PASSWORD_UPPERCASE_REGEX,
} from 'shared/utils/string/password';
import { z } from 'zod';

export const passwordValidationMessages = {
  lowercase: '1 lowercase',
  minimumLength: `Minimum ${MINIMUM_LENGTH} characters`,
  number: '1 number',
  required: 'Required',
  uppercase: '1 uppercase',
};

export type PasswordValidationStatus = {
  minLength: boolean;
  hasLowerCase: boolean;
  hasUpperCase: boolean;
  hasNumber: boolean;
};

export const getPasswordValidationStatus = (
  value: string,
): PasswordValidationStatus => ({
  minLength: value.length >= MINIMUM_LENGTH,
  hasLowerCase: PASSWORD_LOWERCASE_REGEX.test(value),
  hasUpperCase: PASSWORD_UPPERCASE_REGEX.test(value),
  hasNumber: PASSWORD_DIGIT_REGEX.test(value),
});

// Zod has no built-in uppercase/lowercase/digit validators; these regexes
// enforce the displayed password character requirements.
export const passwordSchema = z
  .string({ error: passwordValidationMessages.required })
  .min(1, { error: passwordValidationMessages.required })
  .min(MINIMUM_LENGTH, { error: passwordValidationMessages.minimumLength })
  .regex(PASSWORD_LOWERCASE_REGEX, {
    error: passwordValidationMessages.lowercase,
  })
  .regex(PASSWORD_UPPERCASE_REGEX, {
    error: passwordValidationMessages.uppercase,
  })
  .regex(PASSWORD_DIGIT_REGEX, { error: passwordValidationMessages.number });
